import { getConfig } from '@klpkonsern/appconfig';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

import { LevendeKontrakter } from './views/LevendeKontrakter';

export { LevendeKontrakter };

export const KontraktModuleName = 'kontrakt';

export const KontraktRoutes = {
    kontrakt: () => generateRoute([KontraktModuleName, 'oversikt']),
    kontraktDetaljer: (path: string) =>
        generateRoute([KontraktModuleName, path]),
};

export const KontraktAccess = (user?: User): boolean =>
    (getConfig('WEBAPP_CONTRACT_ENABLE', false) &&
        user &&
        (user.isSuperUser || user.isAdmin)) ||
    false;
